// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-29bf3926] .dropdown-height{height:100%;width:100%}@media (min-width:768px){[data-v-29bf3926] .dropdown-height{height:29rem;width:24rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
